<template>
  <div class="contact-page">
    <section class="page-hero">
      <div class="container">
        <h1>联系我们</h1>
        <p>无论是产品咨询、方案定制还是合作洽谈，都欢迎与我们取得联系，我们将在 1 个工作日内回复您。</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="contact-wrap">
          <!-- 联系方式 -->
          <div>
            <h2 class="contact-title">联系方式</h2>
            <div class="info-item">
              <div class="icon">📍</div>
              <div>
                <b>公司地址</b>
                <span>北京市海淀区北三环西路32号 恒润国际大厦</span>
              </div>
            </div>
            <div class="info-item">
              <div class="icon">✉️</div>
              <div>
                <b>商务邮箱</b>
                <span><a href="mailto:service@workatdata.com">service@workatdata.com</a></span>
              </div>
            </div>
            <div class="info-item">
              <div class="icon">💬</div>
              <div>
                <b>企业微信</b>
                <span>搜索「动态时序科技」添加咨询</span>
              </div>
            </div>
          </div>

          <!-- 留言表单：仅前端校验 + 本地提示，不发起任何后端请求（见 script 注释） -->
          <form class="form" novalidate @submit.prevent="submit">
            <div class="form-row">
              <div class="field">
                <label for="name">您的姓名 *</label>
                <input
                  id="name"
                  type="text"
                  v-model="form.name"
                  placeholder="请输入姓名"
                  :class="{ 'is-error': errors.name }"
                  @input="errors.name = ''"
                >
                <p class="field-err" v-if="errors.name">{{ errors.name }}</p>
              </div>
              <div class="field">
                <label for="company">公司名称</label>
                <input id="company" type="text" v-model="form.company" placeholder="请输入公司名称">
              </div>
            </div>

            <div class="form-row">
              <div class="field">
                <label for="email">电子邮箱</label>
                <input
                  id="email"
                  type="email"
                  v-model="form.email"
                  placeholder="请输入邮箱，便于我们回复"
                  :class="{ 'is-error': errors.email }"
                  @input="errors.email = ''"
                >
                <p class="field-err" v-if="errors.email">{{ errors.email }}</p>
              </div>
              <div class="field">
                <label for="topic">咨询类型</label>
                <select id="topic" v-model="form.topic">
                  <option v-for="item in topics" :key="item">{{ item }}</option>
                </select>
              </div>
            </div>

            <div class="field">
              <label for="message">留言内容 *</label>
              <textarea
                id="message"
                v-model="form.message"
                placeholder="请简单描述您的需求，例如：希望监控哪些业务数据、数据调用场景等"
                :class="{ 'is-error': errors.message }"
                @input="errors.message = ''"
              ></textarea>
              <p class="field-err" v-if="errors.message">{{ errors.message }}</p>
            </div>

            <button class="btn btn-primary" type="submit">提交留言</button>
            <p class="hint">提交即表示同意我们仅将您的信息用于本次咨询联系。</p>
          </form>
        </div>
      </div>
    </section>

    <!-- 到访指引（地图占位） -->
    <section class="section alt">
      <div class="container">
        <div class="section-head">
          <div class="eyebrow">Find Us</div>
          <h2>到访指引</h2>
        </div>
        <div class="map-ph">
          <div class="map-ph-pin">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
          </div>
          <h3>北京市海淀区北三环西路32号 恒润国际大厦</h3>
          <p>地铁大钟寺站步行约 8 分钟；驾车导航请搜索「恒润国际大厦」。地图组件占位：正式上线可在此嵌入高德 / 百度 / 腾讯地图。</p>
          <div class="map-ph-links">
            <a href="https://www.amap.com/search?query=%E6%81%92%E6%B6%A6%E5%9B%BD%E9%99%85%E5%A4%A7%E5%8E%A6&city=110000" target="_blank" rel="noopener">在高德地图中查看 ↗</a>
            <a href="https://map.baidu.com/search/%E6%81%92%E6%B6%A6%E5%9B%BD%E9%99%85%E5%A4%A7%E5%8E%A6/@12959219,4829387,17z" target="_blank" rel="noopener">在百度地图中查看 ↗</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* 联系我们：结构与文案按 website-handoff/contact.html 落地。
   ⚠️ 留言表单**不调用任何后端接口**（M6 明确约束）：只做前端校验 + 本地提示，
      提交成功仅提示并清空表单。如需真实提交，需要单独确认后新增接口。 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default {
  name: 'contact',
  data() {
    return {
      topics: ['数据产品 / API 接口', '技术服务', '合作洽谈', '其他'],
      form: {
        name: '',
        company: '',
        email: '',
        topic: '数据产品 / API 接口',
        message: ''
      },
      errors: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    validate() {
      this.errors = { name: '', email: '', message: '' }
      if (!this.form.name.trim()) {
        this.errors.name = '请填写您的姓名'
      }
      if (this.form.email && !EMAIL_RE.test(this.form.email.trim())) {
        this.errors.email = '请输入正确的邮箱地址'
      }
      if (!this.form.message.trim()) {
        this.errors.message = '请填写留言内容'
      }
      return !this.errors.name && !this.errors.email && !this.errors.message
    },
    submit() {
      if (!this.validate()) return
      // 未接后端：仅本地提示并清空，避免给用户「已提交到服务端」的误解
      this.$message.success('感谢您的留言，我们会尽快与您联系！')
      this.form = {
        name: '',
        company: '',
        email: '',
        topic: '数据产品 / API 接口',
        message: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/contact/index.vue